export const TIMELINE_API_URI = '/rest/greenhopper/1.0/roadmaps/classic/board';
export const TIMELINE_FEATURES_API_URI = '/rest/greenhopper/1.0/roadmaps/features/board';
